<script>
    import { SendRequest, ReleaseMode } from "./APIService";
    import moment from 'moment';

    let searchPurchaseTokenData = "";



    let keys = [];
    let values = [];

    let PurchaseTokenData = {
    };

    $: {
        keys = [];
        values = [];
        for (const [key, value] of Object.entries(PurchaseTokenData)) {
            keys = [...keys, key];
            values = [...values, value];
            console.log(`${key}: ${value}`);
        }
    }

    let StorTypes = [
        "CafeBazaar",
        "GooglePlay",
        "AppStore",
        "TestStore",
        "Myket",
        "SibApp",
        "IranApps",
        "ZarrinPal_Google",
        "ZarrinPal_Apple"
    ];


    let ClientId = [
        "PowerupPack1Value",
        "PowerupPack2Value",
        "PowerupPack3Value",

        "TicketPack1Value",
        "TicketPack2Value",
        "TicketPack3Value",


        "DaubAlertPack1Value",
        "DaubAlertPack2Value",
        "DaubAlertPack3Value",

        "XpBoosterPack1Value",
        "XpBoosterPack2Value",
        "XpBoosterPack3Value",

        "CoinPack1Value",
        "CoinPack2Value",
        "CoinPack3Value",

        "TicketPack4Value",
        "TicketPack5Value",
        "TicketPack6Value",

        "StarterPack",

        "SpecialPack1",
        "SpecialPack2",
        "SpecialPack3",
        "SpecialPack4"
    ]



    function SearchPurchaseToken(){
        SendRequest("GetPurchaseByToken", 'POST', 'purchaeToken=' + searchPurchaseTokenData
            , (response) => {
                console.log("Search token Called");

                delete response.id;
                delete response.shopItemId;

                let x = moment(new Date(response.date)).from(new Date());

                response.PurchaseDate = x;

                delete response.date;
                delete response.type;

                response.store = StorTypes[response.storeType]
                response.itemType = ClientId[response.clientId]

                delete response.storeType;
                delete response.clientId;

                PurchaseTokenData = response;

            });
    }




</script>


<br>
<br>
<br>
<!-- Search Gift Code -->
<div class="row justify-content-md-center">
    <div class="card col-md-8">
        <h5 class="card-header" style="text-align: center;"><h3>Search Purchase Token</h3></h5>

        <div class="card-body">
            <div class="mb-3 row">
                <input type="text" class="form-control" placeholder="PurchaseToken" bind:value={searchPurchaseTokenData}>
            </div>
            <div class="mb-3 row">
                <button class="btn btn-danger" type="button" on:click={SearchPurchaseToken}>Search</button>
            </div>
        </div>
    </div>
</div>


{#if keys.length > 0 }

    <div class="row justify-content-md-center">

        <div class="card col-md-8">
            <div class="card-header">
                <h3>PurchaseToken</h3>
            </div>
            <div class="card-body">
                <table class="table table-bordered table-hover">
                    <thead>
                    <tr>
                        <th scope="col">Item</th>
                        <th scope="col">Value</th>
                    </tr>
                    </thead>
                    <tbody>
                    {#each keys as prop, index}
                        <tr>
                            <!-- <th scope="row">1</th> -->
                            <td>{prop}</td>
                            <td>{JSON.stringify(values[index])}</td>
                        </tr>
                    {/each}
                    </tbody>
                </table>
            </div>
        </div>

    </div>
{/if}


<style>

</style>